import { render } from "./EditPlatFormLevel.vue?vue&type=template&id=331e90e4&scoped=true"
import script from "./EditPlatFormLevel.vue?vue&type=script&lang=js"
export * from "./EditPlatFormLevel.vue?vue&type=script&lang=js"

import "./EditPlatFormLevel.vue?vue&type=style&index=0&id=331e90e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331e90e4"]])

export default __exports__